import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { GetPaymentMode } from "../../../../fnx/paymentMode/getPaymentMode";
import { paymentModeClearData } from "../../../../store/paymentModes/action";
export var usePaymentModes = function (_a) {
    var triggerPaymentMode = _a.triggerPaymentMode, projectId = _a.projectId, setPaymentModeList = _a.setPaymentModeList, setPaymentMode = _a.setPaymentMode, setPaymentModeId = _a.setPaymentModeId, setPaymentModeName = _a.setPaymentModeName;
    var dispatch = useDispatch();
    var _b = GetPaymentMode(triggerPaymentMode, projectId || ""), responsePaymentMode = _b.responsePaymentMode, errorPaymentMode = _b.errorPaymentMode, loadingPaymentMode = _b.loadingPaymentMode;
    useEffect(function () {
        var _a, _b, _c;
        if ((responsePaymentMode === null || responsePaymentMode === void 0 ? void 0 : responsePaymentMode.length) > 0) {
            var paymentRecurrence = responsePaymentMode === null || responsePaymentMode === void 0 ? void 0 : responsePaymentMode.map(function (item) {
                var _a, _b, _c;
                return ({
                    id: (_a = item === null || item === void 0 ? void 0 : item.catalogPaymentMode) === null || _a === void 0 ? void 0 : _a.id,
                    name: (_b = item === null || item === void 0 ? void 0 : item.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description,
                    value: (_c = item === null || item === void 0 ? void 0 : item.catalogPaymentMode) === null || _c === void 0 ? void 0 : _c.code,
                });
            });
            setPaymentModeList(paymentRecurrence);
            var payment = {
                id: (_a = paymentRecurrence === null || paymentRecurrence === void 0 ? void 0 : paymentRecurrence[0]) === null || _a === void 0 ? void 0 : _a.id,
                description: (_b = paymentRecurrence === null || paymentRecurrence === void 0 ? void 0 : paymentRecurrence[0]) === null || _b === void 0 ? void 0 : _b.name,
                code: (_c = paymentRecurrence === null || paymentRecurrence === void 0 ? void 0 : paymentRecurrence[0]) === null || _c === void 0 ? void 0 : _c.value,
            };
            setPaymentMode(payment);
            setPaymentModeId(payment.id);
            setPaymentModeName(payment.code);
            dispatch(paymentModeClearData());
        }
    }, [responsePaymentMode]);
    return {
        responsePaymentMode: responsePaymentMode,
        errorPaymentMode: errorPaymentMode,
        loadingPaymentMode: loadingPaymentMode,
    };
};
